<template>
  <v-dialog
    :value="value"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    @input="$emit('input', $event)"
  >
    <v-card class="tutorial-visualizador">
      <div class="tutorial-visualizador__barra">
        <v-icon color="#5e72e4">mdi-book-open-page-variant-outline</v-icon>
        <div class="tutorial-visualizador__titulo">
          <span class="tutorial-visualizador__kicker">{{
            $t("Tutorial")
          }}</span>
          <strong>{{ titulo }}</strong>
        </div>
        <v-spacer />
        <v-btn icon :aria-label="$t('Fechar')" @click="$emit('input', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
      <div v-if="carregando" class="tutorial-visualizador__estado">
        <v-progress-circular indeterminate size="28" color="#5e72e4" />
        <span>{{ $t("Tutorial_carregando") }}</span>
      </div>
      <div v-else-if="erro" class="tutorial-visualizador__estado">
        {{ $t("Tutorial_erro_carregar") }}
      </div>
      <!-- Sem allow-same-origin: o tutorial roda isolado, sem acesso à sessão do Cajupe. -->
      <iframe
        v-else-if="documento"
        class="tutorial-visualizador__pagina"
        :title="titulo"
        :srcdoc="documento"
        sandbox="allow-scripts allow-popups allow-popups-to-escape-sandbox"
      ></iframe>
    </v-card>
  </v-dialog>
</template>

<script>
import TutorialDataService from "@/services/tutorials/TutorialDataService";
import { documentoTutorial } from "@/utils/tutoriais";

// Exibe o tutorial em HTML de um processo do Siga (tutorialId) ou a prévia do que está sendo editado (conteudo).
export default {
  name: "TutorialVisualizador",
  props: {
    value: { type: Boolean, default: false },
    tutorialId: { type: Number, default: null },
    titulo: { type: String, default: "" },
    conteudo: { type: String, default: null },
  },
  data() {
    return {
      carregado: null,
      carregadoId: null,
      carregando: false,
      erro: false,
    };
  },
  computed: {
    documento() {
      const html = this.conteudo || this.carregado;
      return html ? documentoTutorial(html) : null;
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(aberto) {
        if (aberto) this.carregar();
      },
    },
    tutorialId() {
      if (this.value) this.carregar();
    },
  },
  methods: {
    async carregar() {
      if (this.conteudo || !this.tutorialId) return;
      if (this.carregadoId === this.tutorialId && this.carregado) return;
      this.carregando = true;
      this.erro = false;
      try {
        const { data } = await TutorialDataService.staticHtml(this.tutorialId);
        this.carregado = data.html;
        this.carregadoId = this.tutorialId;
      } catch (e) {
        this.erro = true;
      } finally {
        this.carregando = false;
      }
    },
  },
};
</script>

<style scoped>
.tutorial-visualizador {
  display: flex;
  flex-direction: column;
  height: 100%;
  border-radius: 0 !important;
}

.tutorial-visualizador__barra {
  align-items: center;
  border-bottom: 1px solid #e1e4ed;
  display: flex;
  gap: 12px;
  padding: 10px max(16px, env(safe-area-inset-right, 0px)) 10px
    max(16px, env(safe-area-inset-left, 0px));
}

.tutorial-visualizador__titulo {
  display: flex;
  flex-direction: column;
  line-height: 1.25;
  min-width: 0;
}

.tutorial-visualizador__titulo strong {
  color: #1b2130;
  font-size: 1rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tutorial-visualizador__kicker {
  color: #5e72e4;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.tutorial-visualizador__estado {
  align-items: center;
  color: #586174;
  display: flex;
  flex: 1;
  gap: 12px;
  justify-content: center;
}

.tutorial-visualizador__pagina {
  border: 0;
  flex: 1;
  width: 100%;
}
</style>
